"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var preflight = process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ln07yc-preflight",
  styles: "margin:0;label:preflight;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)(preflight, ";font-family:", theme.font.secondary, ";font-weight:", theme.fontWeight.bold, ";line-height:", theme.lineHeight.leadingXSnug, ";color:", theme.color.monochrome.black, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var h1 = function h1(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";font-size:", theme.fontSize.x7large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:h1;"));
};

var h2 = function h2(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";font-size:", theme.fontSize.x6large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:h2;"));
};

var h3 = function h3(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";font-size:", theme.fontSize.x5large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:h3;"));
};

var h4 = function h4(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";font-size:", theme.fontSize.x4large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:h4;"));
};

var styles = {
  preflight: preflight,
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4
};
exports.styles = styles;
//# sourceMappingURL=heading.styles.js.map